import { useLogoutFunction } from '@propelauth/react';

import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';

interface OrgAssignmentHandlerProps {
  showTimeout?: boolean;
  pollAttempts?: number;
  maxAttempts?: number;
  error?: string | null;
}

export function OrgAssignmentHandler({
  showTimeout = false,
  pollAttempts = 0,
  maxAttempts = 30,
  error = null,
}: OrgAssignmentHandlerProps) {
  const logout = useLogoutFunction();

  const handleLogout = async () => {
    try {
      await logout(true);
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  if (error) {
    return (
      <div className="py-8 space-y-4 text-center">
        <div className="text-sm text-red-600">{error}</div>
        <div className="flex justify-center gap-3">
          <Button onClick={handleRefresh} variant="outline" size="sm">
            Try Again
          </Button>
          <Button onClick={handleLogout} variant="ghost" size="sm">
            Logout
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="py-8 space-y-4 text-center">
      <Spinner size={24} className="mx-auto mb-4 text-black" />

      {/* {pollAttempts > 0 && (
        <div className="text-xs text-neutral-500">Assigning you to your organization...</div>
      )} */}

      {showTimeout && (
        <div className="space-y-3">
          <div className="text-sm text-neutral-600">This is taking longer than expected.</div>
          <div className="flex justify-center gap-3">
            <Button
              onClick={handleRefresh}
              variant="outline"
              size="sm"
              className="text-neutral-600"
            >
              Refresh
            </Button>
            <Button onClick={handleLogout} variant="outline" size="sm" className="text-neutral-600">
              Logout
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
